import { makeStyles } from '@material-ui/core/styles';

const confNumbersInfo = (theme) => {
  return {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(16),
    fontFamily: theme.typography.proxima.semiBold,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  };
};
const passangersInfo = (theme) => {
  return {
    color: theme.palette.grey1,
    fontSize: theme.typography.pxToRem(16),
    fontFamily: theme.typography.proxima.regular,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '250px',
    [theme.breakpoints.only('lg')]: {
      width: '187px',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  };
};
const useStyles = makeStyles((theme) => ({
  mainCard: {
    marginBottom: '20px !important',
    boxShadow: '0px 2px 4px 0px rgba(6, 21, 86, 0.15)',
    background: theme.palette.white,
    borderRadius: '5px',
  },
  flightWrapper: {
    paddingTop: '0 !important',
  },
  FlightSummary: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    borderRadius: 5,
    boxShadow: 'none',
    '& p': {
      fontFamily: theme.typography.proxima.regular,
    },
  },
  cardWrapper: {
    flex: '1',
  },
  passengers: {
    paddingLeft: '30px',
    marginTop: '30px',
    marginBottom: '30px',
    color: theme.palette.grey1,
    width: '249px',
    borderLeft: `1px solid ${theme.palette.border}`,
    '& p': {
      paddingTop: '5px',
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '150%',
    },
    '& p span': {
      display: 'block',
      color: theme.palette.grey2,
      '&:first-child': {
        fontWeight: 'bold',
        paddingBottom: '10px',
        color: theme.palette.grey1,
      },
    },
    [theme.breakpoints.up('xl')]: {
      display: 'block !important',
    },
  },
  departure: {
    '& div:nth-child(8)': {
      textTransform: 'capitalize',
      '& span': {
        textTransform: 'capitalize',
      },
    },
    '& div:nth-child(9)': {
      borderStyle: 'none',
    },
    '& div:nth-child(3)': {
      '& p': {
        marginBottom: 0,
      },
    },
    [theme.breakpoints.up('xl')]: {
      padding: '0',
      margin: '30px',
      borderBottom: `1px solid ${theme.palette.border}`,
      paddingBottom: '30px',
      marginBottom: '0',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '20px 20px 20px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '30px 20px 30px 20px',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '30px 30px 30px 30px !important',
      '& div:nth-child(7)': {
        marginRight: '3px !important',
      },
      '& div:nth-child(8)': {
        display: 'flex',
      },
    },
    [theme.breakpoints.down('sm')]: {
      '& img': {
        padding: 0,
        marginTop: 3,
      },
    },
  },
  returning: {
    [theme.breakpoints.down('lg')]: {
      paddingTop: 20,
    },
    [theme.breakpoints.down('sm')]: {
      '& img': {
        padding: 0,
        marginTop: 3,
      },
    },
  },
  mainCardContainer: {
    padding: '20px !important',
    '&.expandedMode': {
      borderBottom: `solid 1px ${theme.palette.border}`,
    },
    [theme.breakpoints.up('xl')]: {
      padding: '20px 30px !important',
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  flightsContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '& .flightInfo': {
      flex: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingBottom: '20px',
      marginBottom: '20px',
      borderBottom: `solid ${theme.palette.border} 1px`,
      '& .typeOfTrip': {
        fontSize: theme.typography.pxToRem(16),
        fontFamily: theme.typography.proxima.semiBold,
        color: theme.palette.blue1,
      },
      '& .flightCodeDestination': {
        color: theme.palette.blue1,
        fontFamily: theme.typography.proxima.semiBold,
        fontSize: theme.typography.pxToRem(24),
      },
      '& .departDate': {
        color: theme.palette.grey1,
        fontFamily: theme.typography.proxima.regular,
        fontSize: theme.typography.pxToRem(16),
        display: 'flex',
      },
      [theme.breakpoints.down('sm')]: {
        '& .roundTr': {
          width: '107px !important',
          textAlign: 'right',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
        borderRight: `solid 2px ${theme.palette.border}`,
        flexDirection: 'column',
        paddingBottom: '0 ',
        marginBottom: '0 ',
        borderBottom: `0 `,
      },
      '& .flightTypeContainer': {
        [theme.breakpoints.up('md')]: {
          display: 'flex',
        },
        '& .dividerSlash': {
          display: 'none',
          [theme.breakpoints.up('md')]: {
            display: 'flex',
            padding: '0 3px',
          },
        },
      },
    },
    '& .tripDetails': {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flex: '5',
      },
      [theme.breakpoints.up('lg')]: {
        flex: '4',
      },
      [theme.breakpoints.up('xl')]: {
        flex: '7',
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
    },
    '& #multiCityCase': {
      [theme.breakpoints.up('md')]: {
        flex: '2',
      },
      [theme.breakpoints.up('lg')]: {
        flex: 1.5,
      },
      [theme.breakpoints.up('xl')]: {
        flex: '2',
        alignItems: 'flex-start',
      },
    },
    '& .planeInfo': {
      flex: 2,
      display: 'flex',
      flexDirection: 'column-reverse',
      '& .confirmationNumbers': confNumbersInfo(theme),
      '& .confNumber': passangersInfo(theme),
      [theme.breakpoints.up('md')]: {
        marginLeft: '20px',
      },
    },
    '& .passengerInfo': {
      flex: 3,
      [theme.breakpoints.up('md')]: {
        marginLeft: '20px',
      },
      '& .passengers': confNumbersInfo(theme),
      '& .passengersNames': passangersInfo(theme),
    },
    '& .MuiSvgIcon-root': {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    '& .expandMoreContainer': {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.blue2,
    },
    '& .expandMoreFlights': {
      flex: 1,
    },
    '& .expandMoreFlights .passengerInfo': {},
  },
  // flights expanded component
  flightsExpandedContainer: {
    display: 'flex',
  },
  expandedHeader: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(18),
    fontFamily: theme.typography.proxima.semiBold,
    color: theme.palette.blue1,
  },
  divider: {
    '&:last-child': {
      display: 'none',
    },
    color: 'red',
  },
  modalContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    width: '100%',
    color: theme.palette.blue1,
    padding: '36px 20px',

    [theme.breakpoints.up('sm')]: {
      padding: '36px 48px ',
    },
    [theme.breakpoints.up('lg')]: {},

    '& button': {
      width: 40,
      minWidth: 40,
      zIndex: 1,
      padding: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      alignSelf: 'flex-end',

      [theme.breakpoints.up('sm')]: {
        marginRight: '-20px',
        marginTop: '-20px',
      },

      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },

    '& .title': {
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(18),
      marginBottom: 10,

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },

    '& .content p': {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: '120%',

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },

    '& svg': {
      // transform: 'scale(1.5)',
    },

    '& .mobile-list': {
      padding: 0,
      '& li': {
        listStyleType: 'none',
        padding: '10px 8px',

        '&:nth-child(odd)': {
          background: theme.palette.background.default,
        },
      },

      '& span:nth-child(1)': {
        color: theme.palette.grey1,
      },
    },

    '& table': {
      marginTop: 30,
      width: '100%',
      fontSize: theme.typography.pxToRem(16),
      borderCollapse: 'collapse',

      '& tbody tr:nth-child(odd)': {
        background: theme.palette.background.default,
      },

      '& .dateChange': {
        color: theme.palette.grey1,
      },

      '& tr th:nth-child(1), td:nth-child(1)': {
        textAlign: 'left',
        padding: '10px 24px',
      },

      '& tr th:nth-child(2), td:nth-child(2)': {
        textAlign: 'right',
        padding: '10px 24px',
      },
    },
  },
}));

export default useStyles;
